import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemCommonModule } from '../system-common/system-common.module';
import DateRangePicker from '@ui5/webcomponents/dist/DateRangePicker';
import { FullCalendarModule } from '@fullcalendar/angular'; // must go before plugins
import { PremiumDueComponent } from './premium-due/premium-due.component';

import { PolicydetailsModule } from '../policydetails/policydetails.module';
import { MessagesComponent } from './messages/messages.component';
import { LapsedPoliciesComponent } from './lapsed-policies/lapsed-policies.component';
import { BirthDayRemindersComponent } from './birth-day-reminders/birth-day-reminders.component';
import { NotificationService } from './services/notifications.service';
import { NotificationRoutingModule } from './notification-routing.module';

function onAppInit(): () => Promise<any> {
  return (): Promise<any> => {
    DateRangePicker.define();
    return DateRangePicker.define();
  };
}

@NgModule({
  declarations: [BirthDayRemindersComponent, LapsedPoliciesComponent, MessagesComponent, PremiumDueComponent],
  imports: [
    CommonModule,
    NotificationRoutingModule,
    PolicydetailsModule,
    SystemCommonModule,
    FormsModule,
    BrowserModule,
    FullCalendarModule, // register FullCalendar with your app
  ],
  // providers: [NotificationService],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    NotificationService,
    {
      provide: APP_INITIALIZER,
      useFactory: onAppInit,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotificationModule {}
